import React from 'react';
import { Box, Stack } from '@mui/material';

import { useIsClientInMobileMode } from '../../hooks';
import { RightSidebarControlToolbar } from '../../toolbars/top/RightSidebarControlToolbar';
import { BasicInsertionSettingsFloatingBox } from './BasicInsertionSettingsFloatingBox';
import { FloatingOverSceneColumn } from './common/FloatingOverSceneColumn';
import { FullscreenFab } from './FullscreenFab';
import { MutuallyExclusiveCurrentInteractionSettingsBoxes } from './MutuallyExclusiveCurrentInteractionSettingsBoxes';
import { SnappingSettingsFloatingBox } from './snapping-settings/SnappingSettingsFloatingBox';

interface Props {
  sidebarOpen: boolean;
}

export function RightFloatingColumn({ sidebarOpen }: Props) {
  const mobile = useIsClientInMobileMode();

  return (
    <FloatingOverSceneColumn side="right">
      {!mobile && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'flex-start', pointerEvents: 'none' }}>
          <MutuallyExclusiveCurrentInteractionSettingsBoxes />

          <SnappingSettingsFloatingBox />
        </Stack>
      )}

      <BasicInsertionSettingsFloatingBox />

      {mobile && (
        <>
          <Box sx={{ flexGrow: 1 }} />
          <FullscreenFab />
        </>
      )}

      <RightSidebarControlToolbar open={sidebarOpen} onMobile={mobile} />
    </FloatingOverSceneColumn>
  );
}
